import CloseIcon from '@/fsd/shared/ui/icons/Close';
import cx from 'classnames';
import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import style from './Modal.module.scss';

interface ModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  children: React.ReactNode;
  className?: string;
  classNameClose?: string;
  classNameBackground?: string;
  showCloseButton?: boolean;
  size?: 'small' | 'medium' | 'large' | 'auto';
  height?: 'default' | 'auto' | 'fit-content';
  title?: React.ReactNode;
  footer?: React.ReactNode;
  dataTestid?: string;
  onClose?: () => void;
  z?: number;
}

const Modal: React.FC<ModalProps> = ({
  showModal,
  setShowModal,
  children,
  className = '',
  classNameClose = '',
  classNameBackground = '',
  showCloseButton = false,
  size = 'medium',
  height = 'default',
  title,
  footer,
  dataTestid,
  onClose,
  z,
}) => {
  const childrenContentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (childrenContentRef.current) {
      const { scrollHeight, clientHeight } = childrenContentRef.current;
      if (scrollHeight > clientHeight) {
        childrenContentRef.current.classList.add(style.scrollable);
      }
    }
  }, [children]);
  if (!showModal) return null;

  return ReactDOM.createPortal(
    <div style={{ zIndex: z }} className={cx(style.modal, classNameBackground)}>
      <span
        className={style.bg}
        onClick={() => {
          setShowModal(false);
          onClose?.();
        }}
      />
      <div
        className={cx(
          style.content,
          style[size],
          style[`height__${height}`],
          className
        )}
        data-testid={dataTestid}
      >
        {showCloseButton && (
          <button
            className={cx(style.close, classNameClose)}
            onClick={() => {
              setShowModal(false);
              onClose?.();
            }}
          >
            {/* svg close */}
            <CloseIcon />
          </button>
        )}
        {title && <h2 className={cx(style.ModalTitle, 'title')}>{title}</h2>}
        <div ref={childrenContentRef} className={style.childrenContent}>
          {children}
          {footer && <div className={style.footer}>{footer}</div>}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
